<template>
    <b-modal :id="id"
             :no-close-on-backdrop="true"
             :title="$t('brand_create')" ref="innermodal" @hide="mhide">
        <form ref="form">
            <div v-if="$v.$error" class="alert alert-danger x-error">
                <div class="error" v-if="!$v.model.Name.required">- សូមធ្វើការបញ្ជូលឈ្មោះ</div>
            </div>
            <div class="form-group" :class="{ 'form-group-error': $v.model.Name.$error }">
                <div>
                    <input type="text" class="form-control"
                        :placeholder="$t('name')"
                        v-model="$v.model.Name.$model" />
                </div>
            </div>
            <b-form-group>
                <b-form-textarea v-model="model.Description" :placeholder="$t('description')"/>
            </b-form-group>
        </form>
        <div slot="modal-footer">
            <b-btn variant="primary" @click="onSave"><i class="fa fa-floppy-o" aria-hidden="true"></i> {{$t('save')}}</b-btn> &nbsp;
            <b-btn variant="danger" @click="closed"><i class="fa fa-times" aria-hidden="true"></i> {{$t('close')}}</b-btn>
        </div>
    </b-modal>
</template>
<script>
    import { required } from 'vuelidate/lib/validators'
    export default {
        props:{
            id: {
                type: String,
                default: ''
            },
            value: {
                type: Object,
                default: null
            }
        },
        data: function(){
            return {
                model: {
                    Name: ''
                }
            }
        },
        validations:{
            model: {
                Name: {
                    required
                }
            }
        },
        methods: {
            onSave(){
                this.$v.$touch();
                if (!this.$v.$invalid) {
                    let loading = this.$loading.show();
                    this.$api().post('brand/save', this.model).then(res => {
                        if(this.$isValid(res)){
                            this.resetForm();
                            this.$refs.innermodal.hide();
                            this.$emit('done')
                        }
                    }).finally(function(){ loading.hide(); });
                }
            },
            closed: function(){
                this.resetForm();
                this.$refs.innermodal.hide();
            },
            mhide: function(){
                this.resetForm();
            },
            resetForm: function(){
                this.$v.$reset();
                this.model = {
                    Name: ''
                };
            }
        },
        watch: {
            value: function(value){
                this.model = value;
            }
        }
    }
</script>